export const GROUP_BY_CROP = 'crop';
export const META_COLOR = '#696F88';
export const ARCHIVED_COLOR = '#868CA2';
export const HIGHLIGHT_COLOR = '#C6E6FF';
export const SELECTED_HIGHLIGHT_COLOR = '#97C7ED';

// Crop zone shape icon colors (values map to the `neutral` palette in
// tailwind.config.js). Crop zones render as an outlined shape (fill + border)
// to stay visually distinct from a field's solid fill; archived uses a
// lighter, muted pair.
export const CROP_ZONE_ICON_FILL = '#DFE2E7'; // neutral-20 (non-archived fill)
export const CROP_ZONE_ICON_FILL_ARCHIVED = '#F3F4F6'; // neutral-10 (archived fill)
export const CROP_ZONE_ICON_BORDER = '#868CA2'; // neutral-50 (non-archived border)
export const CROP_ZONE_ICON_BORDER_ARCHIVED = '#C2C7D0'; // neutral-30 (archived border)
